<template>
  <div class="p-4">
    <div class="shadow-sm">
      <breadcrumb :listNavs="listNavs" />
    </div>
    <v-card class="p-4">
      <!-- Start Affectation visite technique -->
      <DialogAffectation
        :dialogModel="ModalDeaffectationIng"
        typeAffectation="Ingénieur"
        labelListe="Liste Ingénieur"
        :listeItems="listeIngenieur"
        @change="changeIngenieur($event)"
        @closeDialog="ModalDeaffectationIng = false"
        @affecter="affectuerVisiteTechniqueIng"
      />
      <DialogAffectation
        :dialogModel="ModalDeaffectation"
        typeAffectation="Technicien"
        labelListe="Liste Technicien"
        :listeItems="listeTech"
        @change="changeTechnician($event)"
        @closeDialog="ModalDeaffectation = false"
        @affecter="affectuerVisiteTechnique"
      />

      <!-- End Affectation visite technique -->

      <!-- START MODAL CONFIRMATION -->
      <div id="myModal" class="modal fade">
        <div class="modal-dialog modal-confirm">
          <div class="modal-content">
            <div class="modal-header flex-column">
              <div class="icon-box">
                <i class="material-icons">&#xE5CD;</i>
              </div>
              <h4 class="modal-title w-100">Are you sure?</h4>
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                &times;
              </button>
            </div>
            <div class="modal-body">
              <p>
                Do you really want to delete these records? This process cannot be undone.
              </p>
            </div>
            <div class="modal-footer justify-content-center">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Cancel
              </button>
              <button type="button" class="btn btn-danger">Delete</button>
            </div>
          </div>
        </div>
      </div>

      <!-- END MODAL CONFIRMATION -->

      <!-- START modal description -->
      <v-dialog v-model="dialogDescription" width="500">
        <v-card>
          <v-card-title class="pa-0">
            <v-toolbar :color="$colors[0]" dark>
              <v-icon size="25" class="mr-2">mdi-tooltip-text-outline</v-icon>
              <span class="Poppins pl-0">Description</span>
            </v-toolbar>
          </v-card-title>

          <v-card-text class="mt-4 black--text">
            {{ dialogDescriptionText }}
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined color="error" @click="closeDialogDescription"> Fermer </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END modal description -->

      <!-- START modal Commentaire -->
      <!--<v-dialog v-model="dialogCommentaire" width="500">
        <v-card>
          <v-card-title class="pa-0">
            <v-toolbar :color="$colors[0]" dark>
              <v-icon size="30" class="mr-2">mdi-clipboard-text</v-icon>
              <span class="Poppins pl-0">Commentaire</span>
            </v-toolbar>
          </v-card-title>

          <v-card-text class="mt-4 black--text">
            {{ dialogCommentaireText }}
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined color="error" @click="closeDialogCommentaire"> Fermer </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>-->
      <!-- END modal Commentaire -->

      <loadingComponent
        v-if="loadingRequestVT"
        :dialogProps="dialogLoading"
        messageDialogeProps="erreur"
        :loadingProps="loadingRequestVT"
        :errorProps="false"
      />
      <div style="width: 100%;overflow-x: auto;">
        <datatable
          id="table-validation-cotation"
          :columns="headersTable"
          :sortKey="sortKey"
          :sortOrders="sortOrders"
          @sort="sortBy"
          @search="rechercheData"
        >
          <template v-slot:header>
            <div style="display: flex; justify-content: flex-end; align-items: flex-end">
              <div style="display: flex; flex-direction: row">
                <v-autocomplete
                  label="Filtrer par technicien"
                  :items="listeTech"
                  :item-text="'name'"
                  :item-value="'id'"
                  v-model="tableData.techFilter"
                  multiple
                  outlined
                  dense
                  hide-details
                  @change="getData((pageNumber = 1))"
                  class="mx-4"
                ></v-autocomplete>
                <v-autocomplete
                  label="Filtrer par ingenieur"
                  :items="listeIngenieur"
                  :item-text="'name'"
                  :item-value="'id'"
                  outlined
                  dense
                  v-model="tableData.ingienieurFilter"
                  multiple
                  hide-details
                  @change="getData((pageNumber = 1))"
                  class="mx-4"
                ></v-autocomplete>
              </div>
            </div>
          </template>
          <template v-slot:body>
            <tbody
              class="text-center"
              v-if="itemsTable.length > 0 && loadingRequestVT == false"
            >
              <tr v-for="(item, index) in itemsTable" :key="item.id">
                <td>
                  <router-link
                    :to="{ name: 'Profil Visite Technique', params: { id: item.id } }"
                  >
                    {{ item.title }}
                  </router-link>
                </td>
                <td>{{ !!item?.created_by ? item?.created_by : "Manquant" }}</td>
                <td>{{ item.created_at }}</td>
                <td>{{ item.dateDebut }}</td>
                <td>{{ item.dateFin }}</td>
                <td>{{ item.timeStart }}</td>
                <td>{{ item.timeEnd }}</td>
                <td v-if="item.responsable">
                  <div class="d-flex flex-column align-items-center btn-group">
                    <div class="d-flex flex-row justify-content-center">
                      <span class="text-black">{{ item.responsable.nom }}</span>
                      <div
                        class="d-flex flex-row"
                        v-if="
                          $store.getters.hasPermission('VT', 'affecter_ing') ||
                          $store.getters.hasPermission('VT', 'envelve_ing')
                        "
                      >
                        <v-icon
                          class="dropdown-toggle"
                          data-toggle="collapse"
                          :data-target="'#collapseIng' + index"
                          aria-expanded="false"
                          :aria-controls="'collapseIng' + index"
                          size="20"
                          left
                        >
                          mdi-menu-down
                        </v-icon>
                      </div>
                    </div>
                    <div
                      class="collapse"
                      :id="'collapseIng' + index"
                      style="border: 0px"
                      v-if="
                        $store.getters.hasPermission('VT', 'affecter_ing') ||
                        $store.getters.hasPermission('VT', 'envelve_ing')
                      "
                    >
                      <div class="d-flex flex-row mt-4 mt-lg-2">
                        <v-btn
                          @click="openModalDeaffectationIng(item.id)"
                          class="dropdown-project"
                          v-if="$store.getters.hasPermission('VT', 'affecter_ing')"
                          icon
                          small
                          plain
                        >
                          <v-icon color="blue accent-5"> mdi-account-multiple-plus </v-icon>
                        </v-btn>
                        <!-- START ANNULER LA VISITE-->
                        <v-btn
                          @click="annulerVisiteTechniqueIng(item.id)"
                          class="dropdown-project"
                          v-if="$store.getters.hasPermission('VT', 'envelve_ing')"
                          icon
                          small
                          plain
                        >
                          <v-icon color="red accent-5"> mdi-account-cancel-outline </v-icon>
                        </v-btn>
                        <!-- END ANNULER LA VISITE-->
                      </div>
                    </div>
                  </div>
                </td>
                <td v-else>
                  <div class="d-flex flex-column align-items-center btn-group">
                    <div class="d-flex flex-row justify-content-center">
                      <span class="text-danger">Non affectée</span>
                      <div
                        class="d-flex flex-row"
                        v-if="
                          $store.getters.hasPermission('VT', 'affecter_ing') ||
                          $store.getters.hasPermission('VT', 'envelve_ing')
                        "
                      >
                        <v-icon
                          class="dropdown-toggle"
                          data-toggle="collapse"
                          :data-target="'#collapseIng' + index"
                          aria-expanded="false"
                          :aria-controls="'collapseIng' + index"
                          size="20"
                          left
                        >
                          mdi-menu-down
                        </v-icon>
                      </div>
                    </div>
                    <div
                      class="collapse"
                      :id="'collapseIng' + index"
                      style="border: 0px"
                      v-if="
                        $store.getters.hasPermission('VT', 'affecter_ing') ||
                        $store.getters.hasPermission('VT', 'envelve_ing')
                      "
                    >
                      <div class="d-flex flex-row mt-4 mt-lg-2">
                        <v-btn
                          @click="openModalDeaffectationIng(item.id)"
                          class="dropdown-project"
                          v-if="$store.getters.hasPermission('VT', 'affecter_ing')"
                          icon
                          small
                          plain
                        >
                          <v-icon color="blue accent-5"> mdi-account-multiple-plus </v-icon>
                        </v-btn>
                        <!-- START ANNULER LA VISITE-->
                        <v-btn
                          @click="annulerVisiteTechniqueIng(item.id)"
                          class="dropdown-project"
                          v-if="$store.getters.hasPermission('VT', 'envelve_ing')"
                          icon
                          small
                          plain
                        >
                          <v-icon color="red accent-5"> mdi-account-cancel-outline </v-icon>
                        </v-btn>
                        <!-- END ANNULER LA VISITE-->
                      </div>
                    </div>
                  </div>
                </td>
                <td v-else>
                  <div class="d-flex flex-column align-items-center btn-group">
                    <div>
                      <span style="font-size: smaller; color: red">non affecté(e)</span>
                      <div
                        v-if="
                          $store.getters.hasPermission('VT', 'affecter_ing') ||
                          $store.getters.hasPermission('VT', 'envelve_ing')
                        "
                      >
                        <v-icon
                          class="dropdown-toggle"
                          data-toggle="collapse"
                          :data-target="'#collapseIng' + index"
                          aria-expanded="false"
                          :aria-controls="'collapseIng' + index"
                          size="20"
                          left
                        >
                          mdi-menu-down
                        </v-icon>
                      </div>
                    </div>
                    <div
                      class="collapse"
                      :id="'collapseIng' + index"
                      style="border: 0px"
                      v-if="
                        $store.getters.hasPermission('VT', 'affecter_ing') ||
                        $store.getters.hasPermission('VT', 'envelve_ing')
                      "
                    >
                      <div class="d-flex flex-row justify-content-center mt-4 mt-lg-2">
                        <v-btn
                          @click="openModalDeaffectationIng(item.id)"
                          class="dropdown-project"
                          v-if="$store.getters.hasPermission('VT', 'affecter_ing')"
                          icon
                          small
                          plain
                        >
                          <v-icon color="blue accent-5"> mdi-account-multiple-plus </v-icon>
                        </v-btn>
                        <!-- START ANNULER LA VISITE-->
                      </div>
                    </div>
                  </div>
                </td>
                <td v-if="item.technician">
                  <div class="d-flex flex-column align-items-center btn-group">
                    <div class="d-flex flex-row justify-content-center">
                      <span class="text-black">{{ item.technician.nom }}</span>
                      <div
                        v-if="
                          $store.getters.hasPermission('VT', 'affecter') ||
                          $store.getters.hasPermission('VT', 'envelve')
                        "
                      >
                        <v-icon
                          class="dropdown-toggle"
                          data-toggle="collapse"
                          :data-target="'#collapseTech' + index"
                          aria-expanded="false"
                          :aria-controls="'collapseTech' + index"
                          size="20"
                          left
                        >
                          mdi-menu-down
                        </v-icon>
                      </div>
                    </div>
                    <div
                      class="collapse"
                      :id="'collapseTech' + index"
                      style="border: 0px"
                      v-if="
                        $store.getters.hasPermission('VT', 'affecter') ||
                        $store.getters.hasPermission('VT', 'envelve')
                      "
                    >
                      <div class="d-flex flex-row mt-4 mt-lg-2">
                        <v-btn
                          @click="openModalDeaffectation(item.id)"
                          class="dropdown-project"
                          v-if="$store.getters.hasPermission('VT', 'affecter')"
                          icon
                          small
                          plain
                        >
                          <v-icon color="blue accent-5"> mdi-account-multiple-plus </v-icon>
                        </v-btn>
                        <!-- START ANNULER LA VISITE-->
                        <v-btn
                          @click="annulerVisiteTechnique(item.id)"
                          class="dropdown-project"
                          v-if="$store.getters.hasPermission('VT', 'envelve')"
                          icon
                          small
                          plain
                        >
                          <v-icon color="red accent-5"> mdi-account-cancel-outline </v-icon>
                        </v-btn>
                        <!-- END ANNULER LA VISITE-->
                      </div>
                    </div>
                  </div>
                </td>
                <td v-else>
                  <div class="d-flex flex-column align-items-center btn-group">
                    <div>
                      <span style="font-size: smaller; color: red">non affecté(e)</span>
                      <div
                        v-if="
                          $store.getters.hasPermission('VT', 'affecter') ||
                          $store.getters.hasPermission('VT', 'envelve')
                        "
                      >
                        <v-icon
                          class="dropdown-toggle"
                          data-toggle="collapse"
                          :data-target="'#collapseTech' + index"
                          aria-expanded="false"
                          :aria-controls="'collapseTech' + index"
                          size="20"
                          left
                        >
                          mdi-menu-down
                        </v-icon>
                      </div>
                    </div>
                    <div
                      class="collapse"
                      :id="'collapseTech' + index"
                      style="border: 0px"
                      v-if="
                        $store.getters.hasPermission('VT', 'affecter') ||
                        $store.getters.hasPermission('VT', 'envelve')
                      "
                    >
                      <div class="d-flex flex-row justify-content-center mt-4 mt-lg-2">
                        <v-btn
                          @click="openModalDeaffectation(item.id)"
                          class="dropdown-project"
                          v-if="$store.getters.hasPermission('VT', 'envelve')"
                          icon
                          small
                          plain
                        >
                          <v-icon color="blue accent-5"> mdi-account-multiple-plus </v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <v-btn @click="openDialogDescription(item.description)" icon>
                    <v-icon :color="$colors[0]">mdi-tooltip-text-outline</v-icon>
                  </v-btn>
                </td>
                <!-- <td>
                <v-btn @click="openDialogCommentaire(item.commentaire)" icon>
                  <v-icon :color="$colors[0]">mdi-text-box-search</v-icon>
                </v-btn>
              </td> -->
                <td>
                  <div class="d-flex flex-column align-items-center btn-group">
                    <div class="d-flex flex-row justify-content-center">
                      <small class="small-status" v-if="item.etat == 'refusee'"
                        ><v-icon dense style="color: #ff0000">mdi-close-circle</v-icon
                        ><b class="ml-2">Refusée</b></small
                      >
                      <small class="small-status" v-if="item.etat == 'annuler'"
                        ><v-icon dense style="color: #ff0000">mdi-cancel</v-icon
                        ><b class="ml-2">annulée</b></small
                      >
                      <small class="small-status" v-if="item.etat == 'en_attend'"
                        ><v-icon dense style="color: #2080ee">mdi-clock-outline</v-icon
                        ><b class="ml-2">en attente</b></small
                      >
                      <small class="small-status" v-if="item.etat == 'en_cours'"
                        ><v-icon dense style="color: orange">mdi-progress-clock</v-icon
                        ><b class="ml-2">en cours</b></small
                      >
                      <small class="small-status" v-if="item.etat == 'terminer'"
                        ><v-icon dense style="color: #00e676"
                          >mdi-checkbox-marked-circle-auto-outline</v-icon
                        ><b class="ml-2">terminée</b></small
                      >
                      <small class="small-status" v-if="item.etat == 'pre_valider'"
                        ><v-icon dense style="color: #9c27b0">mdi-progress-check</v-icon
                        ><b class="ml-2">pré validée</b></small
                      >
                      <small class="small-status" v-if="item.etat == 'valider'"
                        ><v-icon dense style="color: #00e676"
                          >mdi-check-circle-outline</v-icon
                        ><b class="ml-2" style="word-wrap: normal">validée</b></small
                      >
                      <div class="d-flex flex-row" v-if="showActionsBtns(item.etat)">
                        <v-icon
                          class="dropdown-toggle"
                          data-toggle="collapse"
                          :data-target="'#collapseStatut' + index"
                          aria-expanded="false"
                          :aria-controls="'collapseStatut' + index"
                          size="20"
                          left
                        >
                          mdi-menu-down
                        </v-icon>
                      </div>
                    </div>
                    <div
                      class="collapse"
                      :id="'collapseStatut' + index"
                      style="border: 0px"
                      v-if="showActionsBtns(item.etat)"
                    >
                      <div class="d-flex flex-row justify-center align-center mt-4 mt-lg-2">
                        <!-- Refuser -->
                        <v-btn
                          class="dropdown-project"
                          title="Refuser"
                          icon
                          small
                          plain
                          @click="
                            ActionsBtns(
                              item.id,
                              'refusee',
                              `Vous êtes sur le point de refuser ${item.title}!`
                            )
                          "
                          v-if="
                            $store.getters.hasPermissionByStatus('VT', item.etat, 'refusee')
                          "
                          color="#FF0000"
                        >
                          <v-icon color="#FF0000"> mdi-close-circle </v-icon>
                        </v-btn>
                        <!-- Annuler -->
                        <v-btn
                          class="dropdown-project"
                          title="Annuler"
                          icon
                          small
                          plain
                          @click="
                            ActionsBtns(
                              item.id,
                              'annuler',
                              `Vous êtes sur le point d'annuler ${item.title}!`
                            )
                          "
                          v-if="
                            $store.getters.hasPermissionByStatus('VT', item.etat, 'annuler')
                          "
                          color="#E91E63"
                        >
                          <v-icon color="#E91E63"> mdi-cancel </v-icon>
                        </v-btn>
                        <!-- Reinitialiser -->
                        <v-btn
                          class="dropdown-project"
                          title="Reinitialiser"
                          icon
                          small
                          plain
                          @click="
                            ActionsBtns(
                              item.id,
                              'en_attend',
                              `Vous êtes sur le point de reinitialiser ${item.title}!`
                            )
                          "
                          v-if="
                            $store.getters.hasPermissionByStatus(
                              'VT',
                              item.etat,
                              'reinitialiser'
                            )
                          "
                          color="#1976D2"
                        >
                          <v-icon color="#1976D2"> mdi-rotate-left </v-icon>
                        </v-btn>
                        <!-- pre valider -->
                        <v-btn
                          class="dropdown-project"
                          title="Pré Valider"
                          icon
                          small
                          plain
                          @click="
                            ActionsBtns(
                              item.id,
                              'pre_valider',
                              `Vous êtes sur le point de pré valider ${item.title}!`
                            )
                          "
                          v-if="
                            $store.getters.hasPermissionByStatus(
                              'VT',
                              item.etat,
                              'pre_valider'
                            )
                          "
                        >
                          <v-icon color="#9C27B0"> mdi-eye-check </v-icon>
                        </v-btn>
                        <!-- valider -->
                        <v-btn
                          class="dropdown-project"
                          title="Valider"
                          icon
                          small
                          plain
                          @click="
                            ActionsBtns(
                              item.id,
                              'valider',
                              `Vous êtes sur le point de valider ${item.title}!`
                            )
                          "
                          v-if="
                            $store.getters.hasPermissionByStatus('VT', item.etat, 'valider')
                          "
                        >
                          <v-icon color="#00E676"> mdi-check-circle </v-icon>
                        </v-btn>
                        <!-- Creer Viste Installation -->
                        <v-btn
                          title="Creer Viste Installation"
                          @click="CreerUneVisteInstallation(item.id)"
                          class="dropdown-project"
                          v-if="
                            $store.getters.hasPermissionByStatus(
                              'VT',
                              item.etat,
                              'create_VI'
                            )
                          "
                          icon
                          small
                          plain
                        >
                          <v-icon color="#0000FF"> mdi-hammer-screwdriver </v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <noDataTable
              class="ma-4"
              v-if="itemsTable.length == 0 && loadingRequestVT == false"
            />
            <progressCircular class="ma-8" v-if="loadingRequestVT == true" />
          </template>
        </datatable>
      </div>
      <pagination
        v-if="itemsTable.length > 0"
        :pagination="pagination"
        @selectNumberOfRecords="rechercheData"
        @first="getData(pagination.firstPage)"
        @last="getData(pagination.lastPage)"
        @prev="getData(pagination.prevPageUrl)"
        @current="getData(pagination.currentPage)"
        @next="getData(pagination.nextPageUrl)"
      >
      </pagination>
    </v-card>
  </div>
</template>
<script>
import DialogAffectation from "@/components/DialogAffectation.vue";
import noDataTable from "@/components/dataTable/no-data-table.vue";
import progressCircular from "@/components/dataTable/progress-circular.vue";
import pagination from "@/components/dataTable/Pagination.vue";
import datatable from "@/components/dataTable/Datatable.vue";
import loadingComponent from "@/components/Loading.vue";
import axios from "@/plugins/axios";
import breadcrumb from "@/components/breadcrumb.vue";
export default {
  name: "ListeFormulaireVisiteTechnique",
  components: {
    DialogAffectation,
    loadingComponent,
    datatable,
    noDataTable,
    progressCircular,
    pagination,
    breadcrumb,
  },
  data() {
    let sortOrders = {};
    let columns = [
      { width: "12vw", label: "Visite Technique", name: "name", sortable: true },
      { width: "12vw", label: "createur de visite", name: "createur", sortable: true },
      { width: "12vw", label: "date de creation", name: "dateCreation", sortable: true },
      { width: "12vw", label: "Date de debut", name: "dateDebut", sortable: true },
      { width: "12vw", label: "Date de fin", name: "dateFin", sortable: true },
      { width: "12vw", label: "Heure de debut", name: "HeureDebut", sortable: false },
      { width: "12vw", label: "Heure de fin", name: "heureFin", sortable: false },
      { width: "12vw", label: "Ingenieur", name: "ingenieur", sortable: true },
      { width: "12vw", label: "Technicien", name: "technician", sortable: true },
      { width: "12vw", label: "Description", name: "description", sortable: false },
      // { width: "12vw", label: "Commentaire", name: "commentaire", sortable: false },
      { width: "11vw", label: "Statut", name: "etat", sortable: true },
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    return {
      listNavs: [
        {
          name: "Visite technique",
          link: "#",
        },
        {
          name: "Liste visite technique",
          link: "#",
        },
      ],
      listeTech: [],
      listeIngenieur: [],
      affectedTo: null,
      technician: null,
      affectedToIng: null,
      ingenieur: null,
      loadingRequestVT: false,
      id_vt: null,
      dialogLoading: false,
      ModalDeaffectation: false,
      ModalDeaffectationIng: false,
      dialogDescription: false,
      //dialogCommentaire: false,
      dialogDescriptionText: "",
      dialogCommentaireText: "",
      columns: columns,
      headersTable: columns,
      itemsTable: [],
      selectedVisiteTechnique: null,
      search: "",
      filterStatus: "tout",
      sortKey: "date",
      sortOrders: sortOrders,
      perPage: ["15", "20", "30"],
      tableData: {
        statusFilter: "",
        draw: 0,
        length: 15,
        search: "",
        column: 0,
        dir: "desc",
        techFilter: [],
        ingienieurFilter: [],
      },
      pagination: {
        perPage: ["10", "15", "30"],
        firstPage: 1,
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
      },
    };
  },

  async created() {
    await this.getData();
  },
  async mounted() {
    await this.getAllTechnicien();
    await this.getAllIngenieur();
  },
  computed: {
    roleUser() {
      return this.$store.getters.getUserRole;
    },
    showActionsBtns() {
      return (status) => {
        return (
          this.$store.getters.hasPermissionByStatus("VT", status, "valider") ||
          this.$store.getters.hasPermissionByStatus("VT", status, "pre_valider") ||
          this.$store.getters.hasPermissionByStatus("VT", status, "annuler") ||
          this.$store.getters.hasPermissionByStatus("VT", status, "refusee") ||
          this.$store.getters.hasPermissionByStatus("VT", status, "reinitialiser") ||
          this.$store.getters.hasPermissionByStatus("VT", status, "create_VI")
        );
      };
    },
  },
  methods: {
    openDialogDescription(text) {
      this.dialogDescription = true;
      this.dialogDescriptionText = text;
    },
    closeDialogDescription() {
      this.dialogDescription = false;
      this.dialogDescriptionText = "";
    },
    /*openDialogCommentaire(text) {
      this.dialogCommentaire = true;
      this.dialogCommentaireText = text;
    },
    closeDialogCommentaire() {
      this.dialogCommentaire = false;
      this.dialogCommentaireText = "";
    },*/
    // get all technicien
    async getAllTechnicien() {
      await fetch(process.env.VUE_APP_URL_API_CLIENT + "getAllTechnicien/", {
        method: "POST",
        body: JSON.stringify({
          token: this.$store.getters.getUserToken,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.error === false && data.result.length > 0) {
            for (let i = 0; i < data.result.length; i++) {
              this.listeTech.push({
                name: data.result[i].nom + " " + data.result[i].prenom,
                id: data.result[i].id,
              });
            }
          }
        });
    },
    // get all ingenieur
    async getAllIngenieur() {
      await fetch(process.env.VUE_APP_URL_API_CLIENT + "getAllIngenieur/", {
        method: "POST",
        body: JSON.stringify({
          token: this.$store.getters.getUserToken,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.error === false && data.result.length > 0) {
            for (let i = 0; i < data.result.length; i++) {
              this.listeIngenieur.push({
                name: data.result[i].nom + " " + data.result[i].prenom,
                id: data.result[i].id,
              });
            }
          }
        });
    },
    openModalDeaffectation(id) {
      this.ModalDeaffectation = true;
      this.id_vt = id;
    },
    openModalDeaffectationIng(id) {
      this.ModalDeaffectationIng = true;
      this.id_vt = id;
    },
    onUpdateVisiteTechnique(event) {},
    changeTechnician(event) {
      this.technician = event;
      console.log(this.technician);
    },
    changeIngenieur(event) {
      this.ingenieur = event;
      console.log(this.ingenieur);
    },
    //effectuerUneVisiteTechniqueAuTech/
    async affectuerVisiteTechnique(id_event) {
      var formData = new FormData();
      formData.append("token", this.$cookies.get("token"));
      formData.append("id_vt", this.id_vt);
      formData.append("id_tech", this.technician);
      await axios({
        url:
          process.env.VUE_APP_URL_API_CLIENT +
          "effectuerUneVisiteTechniqueAuTechForTable",
        method: "POST",
        data: formData,
      })
        .then((res) => {
          if (res.data.status == true) {
            this.ModalDeaffectation = false;
            this.getData();
          } else {
          }
        })
        .catch((err) => {});

      this.technician = null;
    },

    // annulerUneVisiteTechniqueAuTech/
    async annulerVisiteTechnique(vt_item) {
      console.log(vt_item);
      var formData = new FormData();
      formData.append("token", this.$cookies.get("token"));
      formData.append("id_vt", vt_item);
      await axios({
        url:
          process.env.VUE_APP_URL_API_CLIENT + "annulerUneVisiteTechniqueAuTechForTable",
        method: "POST",
        data: formData,
      })
        .then((res) => {
          if (res.data.status == true) {
            this.getData();
          } else {
          }
        })
        .catch((err) => {});
    },
    //effectuerUneVisiteTechniqueAuIng/
    async affectuerVisiteTechniqueIng(id_event) {
      console.log(this.ingenieur);
      var formData = new FormData();
      formData.append("token", this.$cookies.get("token"));
      formData.append("id_vt", this.id_vt);
      formData.append("id_ing", this.ingenieur);
      await axios({
        url:
          process.env.VUE_APP_URL_API_CLIENT + "effectuerUneVisiteTechniqueAuIngForTable",
        method: "POST",
        data: formData,
      })
        .then((res) => {
          if (res.data.status == true) {
            this.ModalDeaffectationIng = false;
            this.getData();
          } else {
          }
        })
        .catch((err) => {});
      this.ingenieur = null;
    },
    // annulerUneVisiteTechniqueAuIng/
    async annulerVisiteTechniqueIng(vt_item) {
      console.log(vt_item);
      var formData = new FormData();
      formData.append("token", this.$cookies.get("token"));
      formData.append("id_vt", vt_item);
      await axios({
        url:
          process.env.VUE_APP_URL_API_CLIENT + "annulerUneVisiteTechniqueAuIngForTable",
        method: "POST",
        data: formData,
      })
        .then((res) => {
          if (res.data.status == true) {
            this.getData();
          } else {
          }
        })
        .catch((err) => {});
    },
    async rechercheData({ type, key }) {
      if (type == "search") {
        var pageNumber = 1;
        this.tableData.search = key;
      } else if (type == "nbrRecords") {
        this.tableData.length = key;
      }
      this.tableData.draw++;
      await fetch(process.env.VUE_APP_URL_API_CLIENT + "getVisiteTechnique/", {
        method: "POST",
        body: JSON.stringify({
          dataTable: this.tableData,
          pageNumber: pageNumber,
          token: this.$store.getters.getUserToken,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.result == true) {
            let respObj = res.data;
            if (this.tableData.draw == respObj.draw) {
              this.itemsTable = respObj.data.data;
              this.configPagination(respObj.data);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getData(pageNumber = 1) {
      this.tableData.draw++;
      this.loadingRequestVT = true;
      this.dialogLoading = true;
      await fetch(process.env.VUE_APP_URL_API_CLIENT + "getVisiteTechnique/", {
        method: "POST",
        body: JSON.stringify({
          dataTable: this.tableData,
          pageNumber: pageNumber,
          token: this.$store.getters.getUserToken,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      })
        .then((response) => response.json())
        .then((res) => {
          console.log(res);

          if (res.result == true) {
            let respObj = res.data;
            console.log(respObj);
            if (this.tableData.draw == respObj.draw) {
              this.itemsTable = respObj.data.data;
              this.configPagination(respObj.data);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.loadingRequestVT = false;
      this.dialogLoading = false;
    },
    CreerUneVisteInstallation(idDC) {
      const props = {
        idDC: idDC,
      };
      this.$router.push({
        path: "/visite-installation/ajoutVisiteInstallation",
        query: props,
      });
    },
    updateVisiteTechnique() {},
    async ActionsBtns(id, status, actionMessage) {
      this.$swal({
        title: "Êtes-vous sûr?",
        text: actionMessage,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#007991",
        cancelButtonColor: "#d33",
        cancelButtonText: "Annuler",
        confirmButtonText: "Je Confirme",
      }).then((result) => {
        if (result.isConfirmed) {
          this.loadingRequestVT = true;
          this.dialogLoading = true;
          var formData = new FormData();
          formData.append("id_vt", id);
          formData.append("status", status);
          formData.append("token", this.$store.getters.getUserToken);
          axios({
            url: process.env.VUE_APP_URL_API_CLIENT + "changeVisiteTechniqueStatus/",
            method: "POST",
            data: formData,
          })
            .then((res) => {
              if (res.status == 200) {
                this.getData(this.pagination.currentPage);
              }
            })
            .catch((err) => {
              console.log(err);
            });
          this.loadingRequestVT = false;
          this.dialogLoading = false;
        }
      });
    },
    spliteList(list) {
      return list.split(",");
    },
    spliteListSlice(list) {
      return list.split(",").slice(1);
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.column = this.getIndex(this.columns, "name", key);
      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getData();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },
  },
};
</script>
<style scoped>
::v-deep .v-expansion-panel-content__wrap {
  padding: 0px;
}
.v-expansion-panel {
  background-color: unset !important;
}
.v-expansion-panel::before {
  box-shadow: none;
}
.small-status {
  width: max-content;
}
.backgroundColor {
  background: #007991 linear-gradient(45deg, #007991 0%, #18aea2 68%);
}
.sizeIcon {
  font-size: initial !important;
}
</style>
